import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatasetTable from './DatasetTable';
import Search from './Search';

const CengageHub = props => {
  const { data, onDataSetChange } = props;
  const [message, setMessage] = useState('');

  return (
    <>
      <div className="flex-justify-sp_between mb-15">
        <h2 className="sub-header-page">Cengage Dataset Hub</h2>
        <Search setMessage={setMessage} />
      </div>
      <DatasetTable
        data={data}
        onChange={onDataSetChange}
        message={message}
      />
    </>

  );
};

CengageHub.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onDataSetChange: PropTypes.func
};


export default CengageHub;

